import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import ReplyButtonPure from './ReplyButtonPure.js'

function ReplyButton({ count, isExpanded, onClick }) {
  return (
    <ReplyButtonPure
      count={count}
      isExpanded={isExpanded}
      onClick={onClick}
      renderIcon={() => <Icon name='chat24' size='large24' />}
      renderChevronIcon={
        count > 0
          ? isExpanded
            ? () => <Icon name='chevron-up24' size='large' />
            : () => <Icon name='chevron-down24' size='large' />
          : null
      }
    />
  )
}

export default ReplyButton
